/**
 * Resolução do tenant no cliente — Story 8.1 (RF-01, `architecture.md` §4).
 *
 * Ordem: **subdomínio** → fallback `X-Tenant-Slug`. Nunca por body ou query
 * string, que é regra dura do `CLAUDE.md` global.
 *
 * O fallback existe porque em desenvolvimento não há wildcard DNS: a gente
 * acessa `localhost:5173` e não `alpha.app.localhost`. Em produção o Traefik
 * entrega o host certo e o subdomínio vence — o header nem chega a ser usado.
 */

const CHAVE_SLUG = 'orc.tenant-slug';

/** Hosts sem subdomínio útil: dev local e acesso por IP. */
function hostSemSubdominio(host: string): boolean {
  if (host === 'localhost' || host.endsWith('.localhost')) {
    // `alpha.localhost` TEM subdomínio; `localhost` puro não.
    return host === 'localhost';
  }
  // IPv4 puro ou domínio de dois rótulos (`exemplo.com`) não carregam tenant.
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return true;
  return host.split('.').length < 3;
}

/** Slug do subdomínio, quando o host tiver um. */
export function slugDoSubdominio(host: string = window.location.hostname): string | undefined {
  if (hostSemSubdominio(host)) return undefined;
  const primeiro = host.split('.')[0]?.toLowerCase();
  if (primeiro === undefined || primeiro === '' || primeiro === 'www') return undefined;
  return primeiro;
}

/**
 * O tenant efetivo desta sessão.
 *
 * Quando o host resolve, ele manda — nem se olha o armazenamento, para que um
 * valor velho guardado no navegador jamais sobreponha o subdomínio real.
 */
export function slugAtual(): string | undefined {
  const doHost = slugDoSubdominio();
  if (doHost !== undefined) return doHost;

  const guardado = sessionStorage.getItem(CHAVE_SLUG);
  if (guardado !== null && guardado !== '') return guardado;

  const doAmbiente = import.meta.env.VITE_TENANT_SLUG;
  return typeof doAmbiente === 'string' && doAmbiente !== '' ? doAmbiente : undefined;
}

/** Só tem efeito quando o host não resolve o tenant (dev). */
export function definirSlugManual(slug: string): void {
  sessionStorage.setItem(CHAVE_SLUG, slug.trim().toLowerCase());
}

/** `true` quando a tela precisa perguntar o tenant ao usuário (dev). */
export function precisaEscolherTenant(): boolean {
  return slugDoSubdominio() === undefined;
}
